import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://dylora-kzzzi63fg-dyloras-projects.vercel.app/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Enrollment API
export const enrollmentAPI = {
  saveEnrollment: async (enrollmentData) => {
    const response = await api.post('/enrollments', enrollmentData);
    return response.data;
  },

  getAllEnrollments: async (password = 'VikramDyD@0720') => {
    // Add password as query parameter for simple auth
    const response = await api.get(`/enrollments?password=${password}`);
    return response.data;
  },

  getEnrollmentById: async (id) => {
    const response = await api.get(`/enrollments/${id}`);
    return response.data;
  },

  updateEnrollment: async (id, updateData) => {
    const response = await api.put(`/enrollments/${id}`, updateData);
    return response.data;
  },

  deleteEnrollment: async (id) => {
    const response = await api.delete(`/enrollments/${id}`);
    return response.data;
  },
};

// Admin API
export const adminAPI = {
  login: async (credentials) => {
    const response = await api.post('/admin/login', credentials);
    return response.data;
  },

  verifyToken: async (token) => {
    const response = await api.post('/admin/verify', { token });
    return response.data;
  },

  getStats: async (password = 'VikramDyD@0720') => {
    const response = await api.get(`/admin/stats?password=${password}`);
    return response.data;
  },
};

// Export API instance
export default {
  ...enrollmentAPI,
  ...adminAPI,
  
  // Helper method for handling errors
  handleError: (error) => {
    if (error.response) {
      // Server responded with error
      throw new Error(error.response.data.message || 'Server error occurred');
    } else if (error.request) {
      // Request made but no response
      throw new Error('No response from server. Please check your connection.');
    } else {
      // Something else happened
      throw new Error(error.message || 'An error occurred');
    }
  },

  // Add auth token to requests
  setAuthToken: (token) => {
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete api.defaults.headers.common['Authorization'];
    }
  },
};